// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

// KYC AADHAR ADD FUNCTION
export const kYCaadharAdd = (aadharData: any) => {
	const data = {
		AadharOtpVerifyToken: aadharData,
	};
	const url = `${API_URL}AadharOtpVerifyDetails`;
	return makeApiCall(url, data);
};

// KYC AADHAR ADD OTP FUNCTION
export const kYCaadharAddotp = (aadharotpData: any) => {
	const data = {
		AADHAROtpVerificationToken: aadharotpData,
	};
	const url = `${API_URL}AadharOTPValidateVerify`;
	return makeApiCall(url, data);
};

// KYC PAN ADD FUNCTION
export const kYCpanAdd = (panData: any) => {
	const data = {
		DocumentVerificationToken: panData,
	};
	const url = `${API_URL}VerifyPanDetailedKYCApp`;
	return makeApiCall(url, data);
};

// KYC GST ADD FUNCTION
export const kYCgstAdd = (gstData: any) => {
	const data = {
		UpdateKYCVerificationToken: gstData,
	};
	const url = `${API_URL}updateBusinessBranch`;
	return makeApiCall(url, data);
};

// KYC CIN ADD FUNCTION
export const kYCcinAdd = (cinData: any) => {
	const data = {
		UpdateKYCVerificationToken: cinData,
	};
	const url = `${API_URL}updateBusinessBranch`;
	return makeApiCall(url, data);
};

// KYC ITR ADD
export const kYCitrAdd = (itrData: any) => {
	const data = {
		UpdateKYCVerificationToken: itrData,
	};
	const url = `${API_URL}updateBusinessBranch`;
	return makeApiCall(url, data);
};

// KYC MCA ADD
export const kYCmcaAdd = (mcaData: any) => {
	const data = {
		UpdateKYCVerificationToken: mcaData,
	};
	const url = `${API_URL}updateBusinessBranch`;
	return makeApiCall(url, data);
};
